import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HotspotService {

  private readonly _open$: Subject<string> = new Subject();

  constructor() { }

  public get onOpen(): Observable<string> {
    return this._open$.asObservable();
  }

  public openById(id: string): void {
    this._open$.next(id);
  }
}
